import React from "react"
import { Link, navigate } from "gatsby"
import { getUser, isLoggedIn, logout } from "../services/auth"

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HomeIcon from '@mui/icons-material/Home';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LogoutIcon from '@mui/icons-material/Logout';

export default function NavBar() {
  let greetingMessage = ""
  if (isLoggedIn()) {

    greetingMessage = `Bonjour ${getUser().denomination}`
    //console.log(getUser());
  } else {
    greetingMessage = "L'acces à l'outil necessite une connexion"
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
        {isLoggedIn() ? (
            <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {greetingMessage}
            </Typography>
            <Tooltip title="Accueil" arrow>
              <IconButton color="inherit" href="/" component={Link} to="/"><HomeIcon/></IconButton>
            </Tooltip>
            <Tooltip title="Profil" arrow>
              <IconButton color="inherit" href="/app/profile" component={Link} to="/app/profile"><DashboardIcon/></IconButton>
            </Tooltip>
            <Tooltip title="modifier mes informations" arrow>
              <IconButton color="inherit" href="/app/moncpt" component={Link} to="/app/moncpt" state= {{ modify:true, id: getUser().identifiant}}><ManageAccountsIcon/></IconButton>
            </Tooltip>
            <Tooltip title="déconnection" arrow>
                <IconButton
                    color="inherit"
                    href="/"
                    onClick={event => {
                    event.preventDefault()
                    logout(() => navigate(`/`))
                    }}
                >
                    <LogoutIcon/>
                </IconButton>
            </Tooltip>
                
            </Toolbar>
            ) : 
            <Toolbar>
            {/*
            
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
            >
                <MenuIcon />
            </IconButton>
            */}
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {greetingMessage}
            </Typography>
            <Tooltip title="Accueil" arrow>
              <IconButton color="inherit" href="/" component={Link} to="/"><HomeIcon/></IconButton>
            </Tooltip>
            <Tooltip title="Profil" arrow>
              <IconButton color="inherit" href="/app/profile" component={Link} to="/app/profile"><DashboardIcon/></IconButton>
            </Tooltip>
            </Toolbar>
            }
        </AppBar>
    </Box>
  )
}